<div class="camera-container">
    <div class="header">
        <h2>{{ 'locker.consumption.image.title' | translate }}</h2>
        <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>

    @if (!capturedImage) {
        <div>
            @if (!isNative) {
                <video #videoElement autoplay playsinline></video>
            }
            <div class="controls">
                <button mat-raised-button color="accent" (click)="capturePhoto()">{{ 'locker.consumption.image.capture' | translate }}</button>
                @if (!isNative && camerasCount > 1) {
                    <button mat-flat-button color="primary" (click)="toggleCamera()">{{ 'locker.consumption.image.toggle' | translate }}</button>
                }
            </div>
        </div>
    } @else {
        <img [src]="capturedImage" alt="Foto tomada" class="preview-img">
        @if (uploadError) {
            <div class="error">{{ 'locker.consumption.image.error' | translate }}</div>
        }
        <div class="controls">
            <button mat-raised-button color="primary" (click)="repeatPhoto()">{{ 'locker.consumption.image.repeat' | translate }}</button>
            <button mat-raised-button color="accent" (click)="uploadPhoto()" [disabled]="isUploading">
                @if (isUploading) {
                    <mat-spinner diameter="20"></mat-spinner>
                } @else {
                    <span>{{ 'locker.consumption.image.upload' | translate }}</span>
                }
            </button>
        </div>
    }

    <canvas #canvasElement hidden></canvas>
</div>
